import * as React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Stack, TextField, FormControl, 
    InputLabel, Select, MenuItem, Button, IconButton, InputAdornment
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

const initialNewUser = { email: '', password: '', nom: '', prenom: '', role: 'comptable' };

export default function CreateUserDialog({ open, onClose, onCreate }) {
    const [form, setForm] = React.useState(initialNewUser);
    const [submitting, setSubmitting] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);

    React.useEffect(() => {
        if (!open) {
            setForm(initialNewUser);
            setShowPassword(false);
        }
    }, [open]);

    const handleCreate = async () => {
        if (!form.email || !form.password || !form.nom || !form.prenom) return;
        
        const trimmedForm = {
            ...form,
            password: form.password.trim()
        };
        setSubmitting(true);
        try { await onCreate(trimmedForm); }
        finally { setSubmitting(false); }
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Créer un nouvel utilisateur</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    <TextField 
                        label="Email" 
                        type="email" 
                        value={form.email} 
                        onChange={(e) => setForm({ ...form, email: e.target.value })} 
                        required 
                    />
                    <TextField 
                        label="Mot de passe" 
                        type={showPassword ? 'text' : 'password'}
                        value={form.password} 
                        onChange={(e) => setForm({ ...form, password: e.target.value })} 
                        required
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={showPassword ? "masquer le mot de passe" : "afficher le mot de passe"}
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField fullWidth label="Prénom" value={form.prenom} onChange={(e) => setForm({ ...form, prenom: e.target.value })} required />
                        <TextField fullWidth label="Nom" value={form.nom} onChange={(e) => setForm({ ...form, nom: e.target.value })} required />
                    </Stack>
                    <FormControl fullWidth>
                        <InputLabel>Rôle</InputLabel>
                        <Select value={form.role} label="Rôle" onChange={(e) => setForm({ ...form, role: e.target.value })}>
                            <MenuItem value="comptable">Comptable</MenuItem>
                            <MenuItem value="admin">Admin</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuler</Button>
                <Button onClick={handleCreate} disabled={submitting} variant="contained">Créer</Button>
            </DialogActions>
        </Dialog>
    );
}